import React, { useEffect, useState } from "react";
import { requestFirebaseNotificationToken } from "../utils/fcm";
import { isLoggedIn } from "../utils/auth";
import axioswToken from "../api/axios";
import { safeLocalStorage } from "../utils/safeStorage";

const DISMISS_KEY = "notif_prompt_dismissed";

export default function NotificationPermissionPopup() {
  const [show, setShow] = useState(false);
  const [requesting, setRequesting] = useState(false);

  useEffect(() => {
    // Sandboxed iframes / locked-down WebViews can throw on Notification
    // access too (permissions-policy denial), not just storage — this
    // popup is a nice-to-have, never worth crashing the page over.
    try {
      if (!("Notification" in window)) return;
      if (Notification.permission !== "default") return;
      if (safeLocalStorage.getItem(DISMISS_KEY) === "1") return;

      // Wait for the cookie consent popup to be answered first so the two
      // never stack on screen at once — see CookieConsentPopup.js.
      if (!safeLocalStorage.getItem("cookie_consent")) {
        const onResolved = () => setShow(true);
        window.addEventListener("cookie-consent-resolved", onResolved, { once: true });
        return () => window.removeEventListener("cookie-consent-resolved", onResolved);
      }

      const timer = setTimeout(() => setShow(true), 1500);
      return () => clearTimeout(timer);
    } catch (e) {
      return undefined;
    }
  }, []);

  const dismiss = () => {
    safeLocalStorage.setItem(DISMISS_KEY, "1");
    setShow(false);
  };

  const allow = async () => {
    setRequesting(true);
    try {
      const token = await requestFirebaseNotificationToken();
      if (token && isLoggedIn()) {
        axioswToken
          .post(`/updateUserFCM`, { FCMToken: token })
          .catch((err) => console.error("Update FCM token failed", err));
      }
    } finally {
      setRequesting(false);
      dismiss();
    }
  };

  if (!show) return null;

  return (
    <div className="notif-popup">
      <div className="notif-popup-icon">
        <i className="fas fa-bell"></i>
      </div>
      <div className="notif-popup-body">
        <p className="notif-popup-title">Stay Updated</p>
        <p className="notif-popup-text">
          Enable notifications for order updates &amp; exclusive offers.
        </p>
      </div>
      <div className="notif-popup-actions">
        <button className="notif-popup-btn notif-popup-btn--ghost" onClick={dismiss}>
          Not Now
        </button>
        <button className="notif-popup-btn notif-popup-btn--primary" onClick={allow} disabled={requesting}>
          {requesting ? "…" : "Allow"}
        </button>
      </div>
      <button className="notif-popup-close" onClick={dismiss} aria-label="Dismiss">
        <i className="fas fa-times"></i>
      </button>
    </div>
  );
}
